import React from 'react'

const AllOrders = () => {
  return (
    <div>AllOrders</div>
  )
}

export default AllOrders